import { addYears } from 'date-fns';

export const { NODE_ENV } = process.env;
export const { ENV } = process.env;

export const API_STATUS_SUCCESS = 'success';
export const API_STATUS_FAILURE = 'failure';
export const API_STATUS_UNAUTHORIZED = 'unauthorized';
export const API_STATUS_AUTH_CODE_SENT = 'code_sent';

export const LIST_VIEW = 'list';
export const CALENDAR_VIEW = 'calendar';

export const DATE_FORMATS = {
  REG_PAGE: {
    DATE_FORMAT: 'yyyy-MM-dd',
    DISPLAY_DATE_FORMAT: 'dd/MM/yyyy',
    MIN_DATE: new Date(1950, 12, 1),
    FILING_MIN_DATE: new Date(2015, 0, 1),
    MAX_DATE: addYears(new Date(), 2),
  },
  FILING_TYPES: {
    DATE_FORMAT: 'yyyy-MM-dd',
    DISPLAY_DATE_FORMAT: 'MM/yyyy',
  },
  MEDIUM_DATE_TIME: 'd MMM yyyy, HH:mm',
  MESSAGES: {
    DATE_FORMAT: 'yyyy-MM-dd',
    DISPLAY_DATE_FORMAT: 'dd/MM/yyyy',
  },
} as const;

export const TAX_CODE_OPTIONS = {
  WIZARD_MAPPING: 'wizard',
  MANUAL_MAPPING: 'manual',
  COPY_FROM: 'copy/from',
} as const;

export const SALES = 'sales';
export const PURCHASES = 'purchases';
export const EMPTY_STRING = '';
export const TRANSACTION_TYPE_GOODS = 'goods';
export const TRANSACTION_TYPE_SERVICES = 'services';
export const OUTPUT = 'output';

export const ADD_DATA = 'add';

export const noop = /* istanbul ignore next */ () => {};
